"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _ArchiveCampaignResponse = _interopRequireDefault(require("../model/ArchiveCampaignResponse"));

var _CampaignResponse = _interopRequireDefault(require("../model/CampaignResponse"));

var _CampaignsResponse = _interopRequireDefault(require("../model/CampaignsResponse"));

var _CancelCampaignResponse = _interopRequireDefault(require("../model/CancelCampaignResponse"));

var _CreateCampaign = _interopRequireDefault(require("../model/CreateCampaign"));

var _CreateCampaignResponse = _interopRequireDefault(require("../model/CreateCampaignResponse"));

var _DeleteCampaignResponse = _interopRequireDefault(require("../model/DeleteCampaignResponse"));

var _HTTPBadRequestError = _interopRequireDefault(require("../model/HTTPBadRequestError"));

var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));

var _LinksResponse = _interopRequireDefault(require("../model/LinksResponse"));

var _PatchCampaign = _interopRequireDefault(require("../model/PatchCampaign"));

var _PatchCampaignResponse = _interopRequireDefault(require("../model/PatchCampaignResponse"));

var _RenderCampaignResponse = _interopRequireDefault(require("../model/RenderCampaignResponse"));

var _ResumeCampaignResponse = _interopRequireDefault(require("../model/ResumeCampaignResponse"));

var _ScheduleCampaign = _interopRequireDefault(require("../model/ScheduleCampaign"));

var _ScheduleCampaignResponse = _interopRequireDefault(require("../model/ScheduleCampaignResponse"));

var _SendTestEmail = _interopRequireDefault(require("../model/SendTestEmail"));

var _SendTestEmailResponse = _interopRequireDefault(require("../model/SendTestEmailResponse"));

var _SuspendCampaignResponse = _interopRequireDefault(require("../model/SuspendCampaignResponse"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
* Campaign service.
* @module api/CampaignApi
* @version integration550
*/
var CampaignApi = /*#__PURE__*/function () {
  /**
  * Constructs a new CampaignApi. 
  * @alias module:api/CampaignApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function CampaignApi(apiClient) {
    _classCallCheck(this, CampaignApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Callback function to receive the result of the archiveCampaign operation.
   * @callback module:api/CampaignApi~archiveCampaignCallback
   * @param {String} error Error message, if any.
   * @param {module:model/ArchiveCampaignResponse} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Archive a campaign
   * You can only delete a campaign when the status is draft. However, if you want to remove a campaign from your list of active campaigns, you can archive it.
   * @param {Number} campaignId 
   * @param {Object} opts Optional parameters
   * @param {Number} opts.accountId 
   * @param {module:api/CampaignApi~archiveCampaignCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/ArchiveCampaignResponse}
   */


  _createClass(CampaignApi, [{
    key: "archiveCampaign",
    value: function archiveCampaign(campaignId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'campaignId' is set

      if (campaignId === undefined || campaignId === null) {
        throw new Error("Missing the required parameter 'campaignId' when calling archiveCampaign");
      }

      var pathParams = {
        'campaign_id': campaignId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ArchiveCampaignResponse["default"];
      return this.apiClient.callApi('/campaigns/{campaign_id}/archive', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the cancelCampaign operation.
     * @callback module:api/CampaignApi~cancelCampaignCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CancelCampaignResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Cancel a campaign
     * @param {Number} campaignId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/CampaignApi~cancelCampaignCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CancelCampaignResponse}
     */

  }, {
    key: "cancelCampaign",
    value: function cancelCampaign(campaignId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'campaignId' is set

      if (campaignId === undefined || campaignId === null) {
        throw new Error("Missing the required parameter 'campaignId' when calling cancelCampaign");
      }

      var pathParams = {
        'campaign_id': campaignId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _CancelCampaignResponse["default"];
      return this.apiClient.callApi('/campaigns/{campaign_id}/cancel', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the createCampaign operation.
     * @callback module:api/CampaignApi~createCampaignCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CreateCampaignResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a campaign
     * @param {module:model/CreateCampaign} createCampaign 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/CampaignApi~createCampaignCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CreateCampaignResponse}
     */

  }, {
    key: "createCampaign",
    value: function createCampaign(_createCampaign, opts, callback) {
      opts = opts || {};
      var postBody = _createCampaign; // verify the required parameter 'createCampaign' is set

      if (_createCampaign === undefined || _createCampaign === null) {
        throw new Error("Missing the required parameter 'createCampaign' when calling createCampaign");
      }

      var pathParams = {};
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _CreateCampaignResponse["default"];
      return this.apiClient.callApi('/campaigns', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the deleteCampaign operation.
     * @callback module:api/CampaignApi~deleteCampaignCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DeleteCampaignResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a campaign
     * @param {Number} campaignId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/CampaignApi~deleteCampaignCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DeleteCampaignResponse}
     */

  }, {
    key: "deleteCampaign",
    value: function deleteCampaign(campaignId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'campaignId' is set

      if (campaignId === undefined || campaignId === null) {
        throw new Error("Missing the required parameter 'campaignId' when calling deleteCampaign");
      }

      var pathParams = {
        'campaign_id': campaignId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _DeleteCampaignResponse["default"];
      return this.apiClient.callApi('/campaigns/{campaign_id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getCampaign operation.
     * @callback module:api/CampaignApi~getCampaignCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CampaignResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show a campaign details
     * @param {Number} campaignId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/CampaignApi~getCampaignCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CampaignResponse}
     */

  }, {
    key: "getCampaign",
    value: function getCampaign(campaignId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'campaignId' is set

      if (campaignId === undefined || campaignId === null) {
        throw new Error("Missing the required parameter 'campaignId' when calling getCampaign");
      }

      var pathParams = {
        'campaign_id': campaignId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _CampaignResponse["default"];
      return this.apiClient.callApi('/campaigns/{campaign_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the listCampaigns operation.
     * @callback module:api/CampaignApi~listCampaignsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CampaignsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show all campaigns
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page  (default to 1)
     * @param {Number} opts.perPage  (default to 50)
     * @param {Boolean} opts.withCount  (default to false)
     * @param {Number} opts.accountId 
     * @param {String} opts.filter Valid Terms:   - `status`   - `name`   - `type`   - `list_id`  Valid Operators:   - `==`  Query separator:   - `;`
     * @param {String} opts.sort Sort term and direction, using syntax `[-|+]term`.  Valid terms:   - `name`   - `created_on`   - `scheduled_for`   - `scheduled_on`   - `updated_on`   - `type`
     * @param {module:api/CampaignApi~listCampaignsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CampaignsResponse}
     */

  }, {
    key: "listCampaigns",
    value: function listCampaigns(opts, callback) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage'],
        'with_count': opts['withCount'],
        'account_id': opts['accountId'],
        'filter': opts['filter'],
        'sort': opts['sort']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _CampaignsResponse["default"];
      return this.apiClient.callApi('/campaigns', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the listLinks operation.
     * @callback module:api/CampaignApi~listLinksCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LinksResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show a campaign links
     * @param {Number} campaignId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {Number} opts.page  (default to 1)
     * @param {Number} opts.perPage  (default to 50)
     * @param {Boolean} opts.withCount  (default to false)
     * @param {module:api/CampaignApi~listLinksCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LinksResponse}
     */

  }, {
    key: "listLinks",
    value: function listLinks(campaignId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'campaignId' is set

      if (campaignId === undefined || campaignId === null) {
        throw new Error("Missing the required parameter 'campaignId' when calling listLinks");
      }

      var pathParams = {
        'campaign_id': campaignId
      };
      var queryParams = {
        'account_id': opts['accountId'],
        'page': opts['page'],
        'per_page': opts['perPage'],
        'with_count': opts['withCount']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _LinksResponse["default"];
      return this.apiClient.callApi('/campaigns/{campaign_id}/links', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the patchCampaign operation.
     * @callback module:api/CampaignApi~patchCampaignCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PatchCampaignResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update a campaign
     * @param {Number} campaignId 
     * @param {module:model/PatchCampaign} patchCampaign 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/CampaignApi~patchCampaignCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PatchCampaignResponse}
     */

  }, {
    key: "patchCampaign",
    value: function patchCampaign(campaignId, _patchCampaign, opts, callback) {
      opts = opts || {};
      var postBody = _patchCampaign; // verify the required parameter 'campaignId' is set

      if (campaignId === undefined || campaignId === null) {
        throw new Error("Missing the required parameter 'campaignId' when calling patchCampaign");
      } // verify the required parameter 'patchCampaign' is set


      if (_patchCampaign === undefined || _patchCampaign === null) {
        throw new Error("Missing the required parameter 'patchCampaign' when calling patchCampaign");
      }

      var pathParams = {
        'campaign_id': campaignId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _PatchCampaignResponse["default"];
      return this.apiClient.callApi('/campaigns/{campaign_id}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the renderCampaign operation.
     * @callback module:api/CampaignApi~renderCampaignCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RenderCampaignResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Render a campaign
     * @param {Number} campaignId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.contactId 
     * @param {Number} opts.accountId 
     * @param {module:api/CampaignApi~renderCampaignCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RenderCampaignResponse}
     */

  }, {
    key: "renderCampaign",
    value: function renderCampaign(campaignId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'campaignId' is set

      if (campaignId === undefined || campaignId === null) {
        throw new Error("Missing the required parameter 'campaignId' when calling renderCampaign");
      }

      var pathParams = {
        'campaign_id': campaignId
      };
      var queryParams = {
        'contact_id': opts['contactId'],
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _RenderCampaignResponse["default"];
      return this.apiClient.callApi('/campaigns/{campaign_id}/render', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the rescheduleCampaign operation.
     * @callback module:api/CampaignApi~rescheduleCampaignCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ScheduleCampaignResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Reschedule a campaign
     * @param {Number} campaignId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:model/ScheduleCampaign} opts.scheduleCampaign 
     * @param {module:api/CampaignApi~rescheduleCampaignCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ScheduleCampaignResponse}
     */

  }, {
    key: "rescheduleCampaign",
    value: function rescheduleCampaign(campaignId, opts, callback) {
      opts = opts || {};
      var postBody = opts['scheduleCampaign']; // verify the required parameter 'campaignId' is set

      if (campaignId === undefined || campaignId === null) {
        throw new Error("Missing the required parameter 'campaignId' when calling rescheduleCampaign");
      }

      var pathParams = {
        'campaign_id': campaignId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ScheduleCampaignResponse["default"];
      return this.apiClient.callApi('/campaigns/{campaign_id}/reschedule', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the resumeCampaign operation.
     * @callback module:api/CampaignApi~resumeCampaignCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResumeCampaignResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Resume a campaign
     * @param {Number} campaignId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/CampaignApi~resumeCampaignCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResumeCampaignResponse}
     */

  }, {
    key: "resumeCampaign",
    value: function resumeCampaign(campaignId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'campaignId' is set

      if (campaignId === undefined || campaignId === null) {
        throw new Error("Missing the required parameter 'campaignId' when calling resumeCampaign");
      }

      var pathParams = {
        'campaign_id': campaignId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ResumeCampaignResponse["default"];
      return this.apiClient.callApi('/campaigns/{campaign_id}/resume', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the scheduleCampaign operation.
     * @callback module:api/CampaignApi~scheduleCampaignCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ScheduleCampaignResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Schedule a campaign
     * @param {Number} campaignId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:model/ScheduleCampaign} opts.scheduleCampaign 
     * @param {module:api/CampaignApi~scheduleCampaignCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ScheduleCampaignResponse}
     */

  }, {
    key: "scheduleCampaign",
    value: function scheduleCampaign(campaignId, opts, callback) {
      opts = opts || {};
      var postBody = opts['scheduleCampaign']; // verify the required parameter 'campaignId' is set

      if (campaignId === undefined || campaignId === null) {
        throw new Error("Missing the required parameter 'campaignId' when calling scheduleCampaign");
      }

      var pathParams = {
        'campaign_id': campaignId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ScheduleCampaignResponse["default"];
      return this.apiClient.callApi('/campaigns/{campaign_id}/schedule', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the sendTestEmail operation.
     * @callback module:api/CampaignApi~sendTestEmailCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SendTestEmailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Send a test email
     * @param {Number} campaignId 
     * @param {module:model/SendTestEmail} sendTestEmail 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/CampaignApi~sendTestEmailCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SendTestEmailResponse}
     */

  }, {
    key: "sendTestEmail",
    value: function sendTestEmail(campaignId, _sendTestEmail, opts, callback) {
      opts = opts || {};
      var postBody = _sendTestEmail; // verify the required parameter 'campaignId' is set

      if (campaignId === undefined || campaignId === null) {
        throw new Error("Missing the required parameter 'campaignId' when calling sendTestEmail");
      } // verify the required parameter 'sendTestEmail' is set


      if (_sendTestEmail === undefined || _sendTestEmail === null) {
        throw new Error("Missing the required parameter 'sendTestEmail' when calling sendTestEmail");
      }

      var pathParams = {
        'campaign_id': campaignId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _SendTestEmailResponse["default"];
      return this.apiClient.callApi('/campaigns/{campaign_id}/send-test', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the suspendCampaign operation.
     * @callback module:api/CampaignApi~suspendCampaignCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SuspendCampaignResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Suspend a campaign
     * @param {Number} campaignId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/CampaignApi~suspendCampaignCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SuspendCampaignResponse}
     */

  }, {
    key: "suspendCampaign",
    value: function suspendCampaign(campaignId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'campaignId' is set

      if (campaignId === undefined || campaignId === null) {
        throw new Error("Missing the required parameter 'campaignId' when calling suspendCampaign");
      }

      var pathParams = {
        'campaign_id': campaignId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _SuspendCampaignResponse["default"];
      return this.apiClient.callApi('/campaigns/{campaign_id}/suspend', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the unarchiveCampaign operation.
     * @callback module:api/CampaignApi~unarchiveCampaignCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ArchiveCampaignResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Unarchive a campaign
     * @param {Number} campaignId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/CampaignApi~unarchiveCampaignCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ArchiveCampaignResponse}
     */

  }, {
    key: "unarchiveCampaign",
    value: function unarchiveCampaign(campaignId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'campaignId' is set

      if (campaignId === undefined || campaignId === null) {
        throw new Error("Missing the required parameter 'campaignId' when calling unarchiveCampaign");
      }

      var pathParams = {
        'campaign_id': campaignId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ArchiveCampaignResponse["default"];
      return this.apiClient.callApi('/campaigns/{campaign_id}/unarchive', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the unscheduleCampaign operation.
     * @callback module:api/CampaignApi~unscheduleCampaignCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ScheduleCampaignResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Unschedule a campaign
     * @param {Number} campaignId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/CampaignApi~unscheduleCampaignCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ScheduleCampaignResponse}
     */

  }, {
    key: "unscheduleCampaign",
    value: function unscheduleCampaign(campaignId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'campaignId' is set

      if (campaignId === undefined || campaignId === null) {
        throw new Error("Missing the required parameter 'campaignId' when calling unscheduleCampaign");
      }

      var pathParams = {
        'campaign_id': campaignId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ScheduleCampaignResponse["default"];
      return this.apiClient.callApi('/campaigns/{campaign_id}/unschedule', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);

  return CampaignApi;
}();

exports["default"] = CampaignApi;